"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
const vault_1 = require("../../api/vault");
const configuration_1 = __importDefault(require("../../common/js/apis/configuration/vault/configuration"));
const AuthorizationStore_1 = __importDefault(require("../../common/js/stores/AuthorizationStore"));
class ProfileStore {
    api = new vault_1.ProfileApi(configuration_1.default);
    internalIsLoading = false;
    onBehalfOfCustomers = [];
    constructor() {
        (0, mobx_1.makeObservable)(this, {
            internalIsLoading: mobx_1.observable,
            onBehalfOfCustomers: mobx_1.observable,
            isLoading: mobx_1.computed,
            customers: mobx_1.computed,
            customerOptions: mobx_1.computed,
            loadOnBehalfOfCustomers: mobx_1.action.bound,
            reset: mobx_1.action.bound,
        });
    }
    get isLoading() {
        return this.internalIsLoading;
    }
    get customers() {
        return this.onBehalfOfCustomers.slice();
    }
    get customerOptions() {
        return this.customers.map((customer) => ({
            value: customer.customerId,
            label: `${customer.customerName} (${customer.customerId})`,
        }));
    }
    loadOnBehalfOfCustomers() {
        if (this.internalIsLoading) {
            return Promise.resolve();
        }
        this.internalIsLoading = true;
        return this.api
            .getOnBehalfOfCustomers()
            .then((0, mobx_1.action)((customers) => {
            this.onBehalfOfCustomers = customers.filter((customer) => customer.customerId !== AuthorizationStore_1.default.customerId);
        }))
            .finally((0, mobx_1.action)(() => {
            this.internalIsLoading = false;
        }));
    }
    reset() {
        this.onBehalfOfCustomers = [];
    }
}
exports.default = new ProfileStore();
